import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { currentAppUrl } from "../../Constants/config";
import { useToast } from "../../Utils/toastContext";
import {
  setUserProfilePic,
  setUserProfilePicDownloadUrl,
} from "../../Redux/store/userSlice";
import useAutoLogout from "../custom-logout/custom-logout";
import SessionWarningModal from "../custom-logout/session-timeout-popup";
import { clearCardCurrencyName } from "../../Redux/store/userSlice";

function Header({
  currentScreen,
  onBack,
  toggleMenu,
  isMenuOpen,
  isMobile,
  logoutCallback,
}) {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const dispatch = useDispatch();
  const roleName = useSelector((state) => state.user.roleName);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const username = useSelector((state) => state.user.username);
  const [activeTab, setActiveTab] = useState("Personal");
  const [selectedItem, setSelectedItem] = useState(0);
  const [hoveredItem, setHoveredItem] = useState(null);
  const navigate = useNavigate();
  const { showToast } = useToast();
  const logoutDropdown = useRef(null);
  const profilePicURL = useSelector((state) => state.user.userProfilePic);
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState("");

  // const handleNotifications = () => setOpen(!open);
  const [readItems, setReadItems] = useState({});

  const handleMarkAsRead = (itemId) => {
    setReadItems((prev) => ({
      ...prev,
      [itemId]: true, // mark specific item as read
    }));
  };
  const historyData = [
    {
      added_by: {
        first_name: "Peter",
        last_name: "Yassa",
        role: "Customer",
        avatar: "/avatar.svg",
      },
      action_text: "has saved the Personal Details Section.",
      unique_id: "1",
      actions: ["Decline", "Confirm"],
      uploaded_at: "2025-11-06T08:26:00",
      notes:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      added_by: {
        first_name: "John",
        last_name: "Anderson",
        role: "Onboarding Staff",
        avatar: "/avatar.svg",
      },
      action_text: "has edited the Email Personal Details Section.",
      unique_id: "2",
      uploaded_at: "2025-11-05T19:34:00",
      notes: "",
      actions: ["Decline", "Confirm"],
    },
    {
      added_by: {
        first_name: "Jason",
        last_name: "Quinn",
        role: "Advisor",
        avatar: "/avatar.svg",
      },
      action_text: "has edited the Date of Birth Personal Details Section.",
      unique_id: "",
      uploaded_at: "2025-09-18T20:00:00",
      notes: "",
      actions: ["Decline", "Confirm"],
    },
    {
      added_by: {
        first_name: "Brian",
        last_name: "Vaughan",
        role: "Admin",
        avatar: "/avatar.svg",
      },
      action_text: "has edited the Address Personal Details Section.",
      unique_id: "",
      uploaded_at: "2025-09-17T19:34:00",
      notes: "",
      actions: ["Decline", "Confirm"],
    },
    {
      added_by: {
        first_name: "John",
        last_name: "Anderson",
        role: "Onboarding Staff",
        avatar: "/avatar.svg",
      },
      action_text: "has edited the Email Personal Details Section.",
      unique_id: "",
      uploaded_at: "2025-09-17T20:00:00",
      notes: "",
      actions: ["Decline", "Confirm"],
    },
  ];
  const notificationsDropdownRef = useRef(null);
  // Format date groups
  const groupByDate = (data) => {
    const groups = {};
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    data.forEach((item) => {
      const itemDate = new Date(item.uploaded_at);
      const itemDateString = itemDate.toDateString();

      let groupKey = itemDateString;

      // Compare with today and yesterday (only date, not time)
      if (itemDate.toDateString() === today.toDateString()) {
        groupKey = "today";
      } else if (itemDate.toDateString() === yesterday.toDateString()) {
        groupKey = "yesterday";
      }

      if (!groups[groupKey]) groups[groupKey] = [];
      groups[groupKey].push(item);
    });

    return groups;
  };
  const groupedData = groupByDate(historyData);

  const handleStayConnected = () => {
    localStorage.setItem(
      "lastActivity",
      (Date.now() + 60 * 60 * 1000).toString()
    );
  };

  const handleLogout = () => {
    localStorage.removeItem("lastActivity");
    console.log("I am in handleLogout")
    localStorage.removeItem("jwtToken");
    dispatch(clearCardCurrencyName());
    window.location.href = "/login";
  };
  const { timeLeft, isWarning, stayConnected } = useAutoLogout(handleLogout, {
    inactivityLimit: 10 * 60 * 1000, // 10 minutes
    warningThreshold: 60 * 1000, // 60 seconds show warning
  });
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        logoutDropdown.current &&
        !logoutDropdown.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
      if (
        notificationsDropdownRef.current &&
        !notificationsDropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChangeMenu = (id) => {
    setSelectedItem(id);
    toggleMenu();
    if (id == 4) {
      sessionStorage.removeItem("redirectAfterLogin");
      localStorage.removeItem("jwtToken");
      dispatch(clearCardCurrencyName());
      navigate("/login");
    }
  };
  const handleMenuToggle = () => {
    toggleMenu();
  };
  const handleNotifications = () => {
    const token = localStorage.getItem("jwtToken");
    if (!token) {
      localStorage.removeItem("jwtToken");
      navigate("/login");
      showToast("Session expired. Please log in again.", "error");
    }
    window.location.href = `${currentAppUrl}/notifications?bTok=${token}`;
  };
  const toggleDropdown = (event) => {
    event.stopPropagation(); // Prevent click from propagating to the document listener
    setIsDropdownOpen((prev) => !prev);
  };
  const menuItemspopUp = [
    // {
    //   id: 1,
    //   label: "Personal Account",
    //   defaultIcon: "/user-search.svg", // Replace with your default icon URL
    //   selectedIcon: "/user-search.svg", // Replace with your selected icon URL
    // },
    // {
    //   id: 2,
    //   label: "Manage Beneficiary",
    //   defaultIcon: "/people-black.svg",
    //   selectedIcon: "/people-white.svg",
    // },
    // {
    //   id: 3,
    //   label: "Document References",
    //   defaultIcon: "/folder-2.svg",
    //   selectedIcon: "/folder-2-white.svg",
    // },
    {
      id: 4,
      label: "Logout",
      defaultIcon: "/logout.svg",
      selectedIcon: "/logout-white.svg",
    },
  ];
  const menuItemspopUpCompany = [
    // {
    //   id: 1,
    //   label: "REIT Account",
    //   defaultIcon: "/buliding.svg", // Replace with your default icon URL
    //   selectedIcon: "/buliding-white.svg", // Replace with your selected icon URL
    // },
    // {
    //   id: 2,
    //   label: "Manage Beneficiary",
    //   defaultIcon: "/people-black.svg",
    //   selectedIcon: "/people-white.svg",
    // },
    // {
    //   id: 3,
    //   label: "Document References",
    //   defaultIcon: "/folder-2.svg",
    //   selectedIcon: "/folder-2-white.svg",
    // },
    {
      id: 4,
      label: "Logout",
      defaultIcon: "/logout.svg",
      selectedIcon: "/logout-white.svg",
    },
  ];
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getProfilePicture = async () => {
    try {
      const response = await GetAPIcalls("/v1/user/me");

      if (response.status == 200) {
        if (response.data.profile_image_url != null) {
          dispatch(setUserProfilePic(response.data.profile_image_url));
          dispatch(
            setUserProfilePicDownloadUrl(
              response.data.profile_image_url_download
            )
          );
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    getProfilePicture();
  }, []);

  return (
    <div className="flex justify-between items-center px-4 py-2 h-16">
      {/* Back Button */}
      {!isMobile && (
        <div className="flex-shrink-0 mt-4">
          {currentScreen !== "/" &&
            currentScreen !== "/customer-list" &&
            currentScreen !== "/advisor-list" &&
            currentScreen !== "/inspecie-transfer-request" &&
            currentScreen !== "/investment-list" &&
            currentScreen !== "/investment-request-list" &&
            currentScreen !== "/product-approval" &&
            currentScreen !== "/product-settings" &&
            currentScreen !== "/my-profile" &&
            currentScreen !== "/stock-list" && (
              <button
                className="flex items-center space-x-2 bg-white px-3 py-3 rounded-xl shadow-md"
                onClick={onBack}
              >
                <img src="/arrow-left.svg" alt="Back" className="w-4 h-4" />
                <span className="text-sm lg:inline hidden font-medium">
                  Back
                </span>
              </button>
            )}
        </div>
      )}

      {/* Menu Icon for Mobile */}
      <div className="flex items-center mt-4 bg-white rounded-xl space-x-6">
        {isMobile && (
          <div
            className="cursor-pointer p-2 relative z-20"
            onClick={handleMenuToggle}
          >
            <div
              className={`w-6 h-0.5 bg-black my-1 transition-transform duration-300 ${
                isMenuOpen ? "rotate-45 translate-y-2" : ""
              }`}
            />
            <div
              className={`w-6 h-0.5 bg-black my-1 transition-opacity duration-300 ${
                isMenuOpen ? "opacity-0" : "opacity-100"
              }`}
            />
            <div
              className={`w-6 h-0.5 bg-black my-1 transition-transform duration-300 ${
                isMenuOpen ? "-rotate-45 -translate-y-2" : ""
              }`}
            />
          </div>
        )}
      </div>
      <div className="flex items-center space-x-4 ml-auto">
        {/* Profile and Notifications */}
        <div
          ref={logoutDropdown}
          className="relative mt-4 flex items-center space-x-6"
        >
          {/* Profile Dropdown */}
          <div
            onClick={toggleDropdown}
            className={`flex items-center space-x-2 rounded-xl p-2 cursor-pointer transition-colors duration-300 ${
              isDropdownOpen ? "bg-black text-white" : "bg-white text-black"
            }`}
          >
            <img
              src={profilePicURL}
              alt="User Avatar"
              className="w-8 h-8 sm:w-10 sm:h-10 rounded-full"
            />
            <div className="hidden sm:block text-sm whitespace-nowrap">
              <p className="font-medium text-[#005A9C]">
                {roleName == "advisor" ? "Advisor" : "Admin"}
              </p>
              <p className={`${isDropdownOpen ? "text-white" : "text-black"}`}>
                {username}
              </p>
            </div>
            <button className="focus:outline-none">
              <img
                src={!isDropdownOpen ? "/header-down.svg" : "/chevron-down.svg"}
                alt="Dropdown Icon"
                className={`transition-all duration-300 ease-in-out transform ${
                  isDropdownOpen ? "scale-100" : "scale-100"
                }`}
              />
            </button>
          </div>
          {isDropdownOpen && (
            <div
              className="absolute top-16 right-0 w-48 md:right-20 sm:w-56 bg-white rounded-lg shadow-lg z-10"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex border-b">
                <button
                  className={`w-1/2 py-2 rounded-tl-lg text-sm font-medium transition-colors duration-300 ${
                    activeTab === "Personal"
                      ? "bg-black text-white"
                      : "bg-white text-black"
                  }`}
                  onClick={() => setActiveTab("Personal")}
                >
                  Personal
                </button>
                <button
                  className={`w-1/2 py-2 rounded-tr-lg text-sm font-medium transition-colors duration-300 ${
                    activeTab === "Company"
                      ? "bg-black text-white"
                      : "bg-white text-black"
                  }`}
                  onClick={() => setActiveTab("Company")}
                >
                  Company
                </button>
              </div>
              <ul className="py-2 px-2">
                {(activeTab === "Personal"
                  ? menuItemspopUp
                  : menuItemspopUpCompany
                ).map((item) => (
                  <li
                    key={item.id}
                    onMouseEnter={() => setHoveredItem(item.id)}
                    onMouseLeave={() => setHoveredItem(null)}
                    onClick={() => handleChangeMenu(item.id)}
                    className={`flex items-center px-4 py-2 rounded-md space-x-2 cursor-pointer transition-all duration-300 ${
                      hoveredItem === item.id || selectedItem === item.id
                        ? "bg-black text-white"
                        : "text-black hover:bg-black hover:text-white"
                    }`}
                  >
                    <img
                      src={
                        hoveredItem === item.id || selectedItem === item.id
                          ? item.selectedIcon
                          : item.defaultIcon
                      }
                      alt={item.label}
                      className="w-4 h-4 sm:w-5 sm:h-5"
                    />
                    <span className="text-xs sm:text-sm">{item.label}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {/* Notifications */}
          <div className="relative" ref={notificationsDropdownRef}>
            {/* Lamp / Notification Button */}
            <button
              onClick={handleNotifications}
              aria-label="Notifications"
              className="relative bg-white h-12 p-2 rounded-xl focus:outline-none"
            >
              <img
                src="/lamp.svg"
                alt="Notifications"
                className="w-6 h-6 sm:w-8"
              />
              <span className="absolute -top-1 -right-1 bg-[#FF5050] text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
                {historyData.length}
              </span>
            </button>

            {/* Notification Dropdown */}
            {open && (
              <div className="absolute right-0 mt-3 w-[350px] sm:w-[420px] bg-white border border-gray-200 rounded-2xl shadow-lg z-50">
                {/* Header */}
                <div className="flex justify-between items-center px-4 py-3 border-b border-gray-100">
                  <div className="flex items-center gap-2">
                    <img
                      src="/lamp.svg"
                      alt="Notifications"
                      className="w-5 h-5 sm:w-6 sm:h-6"
                    />
                    <h3 className="font-medium text-black text-sm sm:text-base">
                      Notifications
                    </h3>
                  </div>
                  <div className="flex items-center gap-2">
                    <button className="text-xs sm:text-sm text-black font-medium underline whitespace-nowrap">
                      Mark all as read
                    </button>
                    <img
                      onClick={() => {
                        setOpen(false);
                      }}
                      src="/add.svg"
                      alt="Add"
                      className="w-10 h-10 cursor-pointer"
                    />
                  </div>
                </div>
                <div className=" text-xs font-medium pt-6 pr-4 flex-wrap items-center">
                  <div className="flex mb-2 ml-2">
                    <button
                      onClick={() => {
                        setFilter("");
                      }}
                      className={`shadow-md flex items-center justify-center gap-1 px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
                        filter === ""
                          ? "bg-black text-white"
                          : "bg-white text-black"
                      }`}
                    >
                      <span>All</span>
                      <span className="bg-[#FF5050] text-white text-[10px] rounded-full px-1.5 py-[1px]">
                        12
                      </span>
                    </button>
                    <button
                      onClick={() => {
                        setFilter("inbox");
                      }}
                      className={`shadow-md flex items-center justify-center gap-1  lg:px-4 px-2 py-2 border-r border-gray-100 ${
                        filter === "inbox"
                          ? "bg-black text-white"
                          : "bg-white text-black"
                      }`}
                    >
                      <span>Inbox</span>
                      <span className="bg-[#FF5050] text-white text-[10px] rounded-full px-1.5 py-[1px]">
                        10
                      </span>
                    </button>
                    <button
                      onClick={() => {
                        setFilter("general");
                      }}
                      className={`shadow-md flex items-center justify-center gap-1 relative px-4 py-2 rounded-r-xl ${
                        filter === "general"
                          ? "bg-black text-white"
                          : "bg-white text-black"
                      }`}
                    >
                      <span>General</span>
                      <span className="bg-[#FF5050] text-white text-[10px] rounded-full px-1.5 py-[1px]">
                        10
                      </span>
                    </button>
                  </div>
                </div>

                {/* Notifications List */}
                {/* <div className="max-h-[400px] overflow-y-auto p-3 space-y-3">
                  <p className="text-gray-400 text-xs font-medium px-2">
                    Today
                  </p>
                  {notifications.map((n) => (
                    <div
                      key={n.id}
                      className="bg-[#F8FAFF] border border-gray-100 rounded-xl p-3 shadow-sm hover:shadow-md transition"
                    >
                      <div className="flex items-start gap-3">
                        <img
                          src="/avatar.svg"
                          alt={n.name}
                          className="w-8 h-8 rounded-full object-cover border border-gray-200"
                        />
                        <div className="flex-1 text-sm text-gray-700">
                          <p>
                            <span className="font-semibold">{n.name}</span>{" "}
                            <span className="text-[#3047EC] font-semibold">
                              {n.role}
                            </span>{" "}
                            {n.message}
                          </p>

                          {n.actions.length > 0 && (
                            <div className="flex gap-2 mt-2">
                              {n.actions.map((action, i) => (
                                <button
                                  key={i}
                                  className={`px-3 py-1 rounded-lg text-xs font-medium ${
                                    action === "Confirm" || action === "Approve"
                                      ? "bg-[#E7EDFF] text-[#1A4CB4]"
                                      : "bg-white border text-gray-600"
                                  }`}
                                >
                                  {action}
                                </button>
                              ))}
                            </div>
                          )}

                          <div className="text-gray-400 text-xs mt-1">
                            {n.time}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div> */}
                <div className="text-xs space-y-6 h-[60vh] overflow-y-auto px-2 mb-4">
                  {Object.entries(groupedData).map(
                    ([date, items], groupIndex) => (
                      <div key={groupIndex} className="space-y-3">
                        {/* Date Divider */}
                        <div className="relative flex items-center justify-center">
                          <div className="absolute w-full border-t border-gray-300"></div>
                          <span className="relative bg-white rounded-full font-semibold px-4 text-black border text-xs font-medium">
                            {date === "today"
                              ? "Today"
                              : date === "yesterday"
                              ? "Yesterday"
                              : date}
                          </span>
                        </div>

                        {/* Items */}
                        {items.map((item, index) => {
                          const isRead = readItems[item.unique_id];
                          return (
                            <div
                              key={index}
                              onClick={() => handleMarkAsRead(item.unique_id)}
                              className={`p-4 rounded-md cursor-pointer transition-all duration-200 ${
                                !isRead ? "bg-blue-50" : "bg-gray-50"
                              }`}
                            >
                              <div className="flex items-start justify-between">
                                {/* Left: Blue line + Avatar + Content */}
                                <div className="flex items-start space-x-3">
                                  {/* Blue line indicator for unread */}
                                  {!isRead && (
                                    <img
                                      src="/unread-notification.svg"
                                      alt="User Avatar"
                                      className="mt-4"
                                    />
                                  )}

                                  {/* Avatar */}
                                  <img
                                    src={item.added_by.avatar || "/avatar.svg"}
                                    alt="User Avatar"
                                    className="h-10 w-10 rounded-full border"
                                  />

                                  {/* Text */}
                                  <div>
                                    <p className="text-xs">
                                      <span className="font-medium">
                                        {item.added_by.first_name}{" "}
                                        {item.added_by.last_name}
                                      </span>{" "}
                                      <span className="text-[#3047EC] font-medium">
                                        {item.added_by.role}
                                      </span>{" "}
                                      <span className="text-gray-600">
                                        {item.action_text}{" "}
                                      </span>
                                      <span className="font-medium">
                                        {item.unique_id}
                                      </span>
                                    </p>

                                    {item.actions?.length > 0 && (
                                      <div className="flex gap-2 mt-2">
                                        {item.actions.map((action, i) => (
                                          <button
                                            key={i}
                                            className={`px-3 py-1 rounded-lg text-xs font-medium ${
                                              action === "Confirm" ||
                                              action === "Approve"
                                                ? "bg-[#3047EC] text-white"
                                                : "bg-white border border-black text-black"
                                            }`}
                                          >
                                            {action}
                                          </button>
                                        ))}
                                      </div>
                                    )}

                                    {/* Time */}
                                    <p className="text-xs mt-2 text-gray-500 flex items-center space-x-2">
                                      <img
                                        src="/clock-black.svg"
                                        alt="Time Icon"
                                        className="h-4 w-4"
                                      />
                                      <span>
                                        {new Date(
                                          item.uploaded_at
                                        ).toLocaleTimeString([], {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <SessionWarningModal
        isOpen={isWarning}
        timeLeft={timeLeft}
        onStayConnected={stayConnected}
        onLogout={handleLogout}
      />
    </div>
  );
}

export default Header;
